export const data = [
    {
        "PULGADAS":1.0,
        "70":1.2,
        "80":1.4,
        "100":1.7,
        "120":2.1,
        "130":2.2,
        "140":2.4,
        "150":2.6
    },
    {
        "PULGADAS":1.5,
        "70":2.1,
        "80":2.4,
        "100":3.0,
        "120":3.6,
        "130":3.9,
        "140":4.2,
        "150":4.5
    },
    {
        "PULGADAS":2.0,
        "70":3.0,
        "80":3.4,
        "100":4.3,
        "120":5.1,
        "130":5.6,
        "140":6.0,
        "150":6.4
    },
    {
        "PULGADAS":2.5,
        "70":4.3,
        "80":4.9,
        "100":6.15,
        "120":7.35,
        "130":8.0,
        "140":8.6,
        "150":9.2
    },
    {
        "PULGADAS":3.0,
        "70":5.6,
        "80":6.4,
        "100":8.0,
        "120":9.6,
        "130":10.4,
        "140":11.2,
        "150":12.0
    },
    {
        "PULGADAS":3.5,
        "70":7.0,
        "80":8.0,
        "100":10.0,
        "120":12.0,
        "130":13.0,
        "140":14.0,
        "150":15.0
    },
    {
        "PULGADAS":4.0,
        "70":8.4,
        "80":9.6,
        "100":12.0,
        "120":14.4,
        "130":15.6,
        "140":16.8,
        "150":18.0
    },
    {
        "PULGADAS":4.5,
        "70":9.9,
        "80":11.35,
        "100":14.2,
        "120":17.05,
        "130":18.5,
        "140":19.9,
        "150":21.3
    },
    {
        "PULGADAS":5.0,
        "70":11.4,
        "80":13.1,
        "100":16.4,
        "120":19.7,
        "130":21.4,
        "140":23.0,
        "150":24.6
    },
    {
        "PULGADAS":5.5,
        "70":13.25,
        "80":15.2,
        "100":19.0,
        "120":22.8,
        "130":24.7,
        "140":26.6,
        "150":28.5
    },
    {
        "PULGADAS":6.0,
        "70":15.1,
        "80":17.3,
        "100":21.6,
        "120":25.9,
        "130":28.0,
        "140":30.2,
        "150":32.4
    },
    {
        "PULGADAS":6.5,
        "70":16.7,
        "80":19.1,
        "100":23.85,
        "120":28.65,
        "130":31.0,
        "140":33.1,
        "150":36.15
    },
    {
        "PULGADAS":7.0,
        "70":18.3,
        "80":20.9,
        "100":26.1,
        "120":31.4,
        "130":34.0,
        "140":36.0,
        "150":39.9
    },
    {
        "PULGADAS":7.5,
        "70":20.15,
        "80":23.0,
        "100":28.75,
        "120":34.55,
        "130":37.45,
        "140":40.0,
        "150":43.5
    },
    {
        "PULGADAS":8.0,
        "70":22.0,
        "80":25.1,
        "100":31.4,
        "120":37.7,
        "130":40.9,
        "140":44.0,
        "150":47.1
    },
    {
        "PULGADAS":8.5,
        "70":23.85,
        "80":27.25,
        "100":35.05,
        "120":40.9,
        "130":44.3,
        "140":47.7,
        "150":51.1
    },
    {
        "PULGADAS":9.0,
        "70":25.7,
        "80":29.4,
        "100":38.7,
        "120":44.1,
        "130":47.7,
        "140":51.4,
        "150":55.1
    },
    {
        "PULGADAS":9.5,
        "70":27.65,
        "80":31.6,
        "100":40.5,
        "120":47.4,
        "130":51.35,
        "140":55.3,
        "150":59.25
    },
    {
        "PULGADAS":10.0,
        "70":29.6,
        "80":33.8,
        "100":42.3,
        "120":50.7,
        "130":55.0,
        "140":59.2,
        "150":63.4
    },
    {
        "PULGADAS":10.5,
        "70":31.55,
        "80":36.05,
        "100":45.1,
        "120":54.05,
        "130":58.6,
        "140":63.1,
        "150":67.6
    },
    {
        "PULGADAS":11.0,
        "70":33.5,
        "80":38.3,
        "100":47.9,
        "120":57.4,
        "130":62.2,
        "140":67.0,
        "150":71.8
    },
    {
        "PULGADAS":11.5,
        "70":35.45,
        "80":40.5,
        "100":50.65,
        "120":60.75,
        "130":65.85,
        "140":70.9,
        "150":75.95
    },
    {
        "PULGADAS":12.0,
        "70":37.4,
        "80":42.7,
        "100":53.4,
        "120":64.1,
        "130":69.5,
        "140":74.8,
        "150":80.1
    },
    {
        "PULGADAS":12.5,
        "70":39.35,
        "80":44.95,
        "100":56.2,
        "120":67.2,
        "130":73.1,
        "140":78.7,
        "150":84.3
    },
    {
        "PULGADAS":13.0,
        "70":41.3,
        "80":47.2,
        "100":59.0,
        "120":70.3,
        "130":76.7,
        "140":82.6,
        "150":88.5
    },
    {
        "PULGADAS":13.5,
        "70":43.25,
        "80":49.45,
        "100":61.8,
        "120":73.9,
        "130":80.3,
        "140":86.5,
        "150":92.7
    },
    {
        "PULGADAS":14.0,
        "70":45.2,
        "80":51.7,
        "100":64.6,
        "120":77.5,
        "130":83.9,
        "140":90.4,
        "150":96.9
    },
    {
        "PULGADAS":14.5,
        "70":47.1,
        "80":55.35,
        "100":67.3,
        "120":80.75,
        "130":87.45,
        "140":94.2,
        "150":100.95
    },
    {
        "PULGADAS":15.0,
        "70":49.0,
        "80":59.0,
        "100":70.0,
        "120":84.0,
        "130":91.0,
        "140":98.0,
        "150":105.0
    },
    {
        "PULGADAS":15.5,
        "70":53.45,
        "80":59.75,
        "100":72.75,
        "120":87.35,
        "130":94.6,
        "140":101.9,
        "150":109.2
    },
    {
        "PULGADAS":16.0,
        "70":57.9,
        "80":60.5,
        "100":75.5,
        "120":90.7,
        "130":98.2,
        "140":105.8,
        "150":113.4
    },
    {
        "PULGADAS":16.5,
        "70":57.1,
        "80":62.4,
        "100":77.95,
        "120":93.6,
        "130":101.35,
        "140":109.2,
        "150":117.0
    },
    {
        "PULGADAS":17.0,
        "70":56.3,
        "80":64.3,
        "100":80.4,
        "120":96.5,
        "130":104.5,
        "140":112.6,
        "150":120.6
    },
    {
        "PULGADAS":17.5,
        "70":58.05,
        "80":66.3,
        "100":82.9,
        "120":99.5,
        "130":107.8,
        "140":116.1,
        "150":124.35
    },
    {
        "PULGADAS":18.0,
        "70":59.8,
        "80":68.3,
        "100":85.4,
        "120":102.5,
        "130":111.1,
        "140":119.6,
        "150":128.1
    },
    {
        "PULGADAS":18.5,
        "70":61.35,
        "80":69.65,
        "100":87.65,
        "120":105.1,
        "130":113.95,
        "140":122.6,
        "150":131.45
    },
    {
        "PULGADAS":19.0,
        "70":62.9,
        "80":71.0,
        "100":89.9,
        "120":107.7,
        "130":116.8,
        "140":125.6,
        "150":134.8
    },
    {
        "PULGADAS":19.5,
        "70":19.5,
        "80":73.05,
        "100":91.9,
        "120":109.85,
        "130":119.4,
        "140":128.5,
        "150":137.8
    },
    {
        "PULGADAS":20.0,
        "70":65.7,
        "80":75.1,
        "100":93.9,
        "120":112.0,
        "130":122.0,
        "140":131.4,
        "150":140.8
    },
    {
        "PULGADAS":20.5,
        "70":67.2,
        "80":76.45,
        "100":95.6,
        "120":114.0,
        "130":124.25,
        "140":133.8,
        "150":143.35
    },
    {
        "PULGADAS":21.0,
        "70":68.7,
        "80":77.8,
        "100":97.3,
        "120":116.0,
        "130":126.5,
        "140":136.2,
        "150":145.9
    },
    {
        "PULGADAS":21.5,
        "70":69.35,
        "80":78.9,
        "100":98.65,
        "120":118.0,
        "130":128.25,
        "140":138.1,
        "150":147.95
    },
    {
        "PULGADAS":22.0,
        "70":70.0,
        "80":80.0,
        "100":100.0,
        "120":120.0,
        "130":130.0,
        "140":140.0,
        "150":150.0
    }
];